import { isMobile, isTablet } from '@/modules/functions';

export class AboutHistorySlider {
  /** @type {HTMLElement} */
  history;
  /** @type {HTMLElement} */
  slider;
  /** @type {HTMLElement} */
  sliderOuter;
  /** @type {NodeListOf<HTMLElement>} */
  sliderItems;
  /** @type {NodeListOf<HTMLElement>} */
  sliderItemsShowed;
  /** @type {number} */
  sliderItemsLength;
  /** @type {number} */
  sliderItemWidth;
  /** @type {HTMLElement} */
  sliderPrev;
  /** @type {HTMLElement} */
  sliderNext;
  /** @type {number} */
  sliderCurrentIndex;
  /** @type {HTMLElement} */
  caption;
  /** @type {number} */
  showedItems = 6;

  constructor() {}

  init() {
    this.history = document.querySelector('.about-history');
    if (!this.history) return;
    this.caption = document.querySelector('.about-history-caption');

    this.initSlider();
  }

  initSlider() {
    this.slider = document.querySelector('.about-history-slider');
    this.sliderItems = this.slider.querySelectorAll(
      '.about-history-slider-item'
    );
    this.sliderItemsLength = this.sliderItems.length;
    this.sliderOuter = this.slider.querySelector('.about-history-slider-outer');
    this.initNavigation();
    this.initSelectActive();
    this.checkResponsive();

    this.sliderItemWidth =
      this.slider.getBoundingClientRect().width / this.showedItems;
    this.sliderOuter.style.width =
      this.sliderItemsLength * this.sliderItemWidth + 'px';

    this.sliderItems.forEach((el) => {
      el.style.width = this.sliderItemWidth + 'px';
    });

    this.sliderCurrentIndex = 0;
    const firstItem = this.sliderItems.item(0);
    this.addActive(firstItem);
    this.changeOtherElements(firstItem);

    this.setFirstShowed();
  }

  setFirstShowed() {
    this.setShowedItems();
    this.clearShowedItems();

    let i = 0;
    while (i < this.showedItems) {
      const item = this.sliderItems.item(i);
      if (item) {
        item.classList.add('showed');
      }
      i++;
    }

    this.setShowedItems();
  }

  checkResponsive() {
    if (isTablet()) {
      this.showedItems = 5;
    }
    if (isMobile()) {
      this.showedItems = 3;
    }
  }

  initSelectActive() {
    this.sliderItems.forEach((el) => {
      el.addEventListener('click', () => {
        this.changeSlide(el);
        this.sliderCurrentIndex = this.getIndexSliderItem(el);
      });
    });
  }

  initNavigation() {
    this.sliderPrev = document.querySelector('.about-history-slider-prev');
    this.sliderNext = document.querySelector('.about-history-slider-next');

    this.sliderPrev.addEventListener('click', () => {
      if (this.sliderCurrentIndex > 0) {
        this.goPrev();
      }
    });

    this.sliderNext.addEventListener('click', () => {
      if (this.sliderCurrentIndex < this.sliderItemsLength - 1) {
        this.goNext();
      }
    });
  }

  removeActive() {
    const active = this.slider.querySelector(
      '.about-history-slider-item.active'
    );
    if (active) {
      active.classList.remove('active');
    }
  }

  /**
   *
   * @param {HTMLElement} el
   */
  addActive(el) {
    el.classList.add('active');
  }

  /**
   *
   * @param {HTMLElement} el
   */
  changeOtherElements(el) {
    const date = el.dataset.date;

    const activeContent = this.caption.querySelector(
      '.about-history-content.active'
    );
    const activeImage = this.history.querySelector(
      '.about-history-images-item.active'
    );

    if (activeContent) {
      activeContent.classList.remove('active');
    }

    if (activeImage) {
      activeImage.classList.remove('active');
    }

    const currentContent = this.caption.querySelector(
      `.about-history-content[data-date="${date}"]`
    );

    if (currentContent) {
      currentContent.classList.add('active');
    }

    const currentImage = this.history.querySelector(
      `.about-history-images-item[data-date="${date}"]`
    );

    if (currentImage) {
      currentImage.classList.add('active');
    }
  }

  goPrev() {
    this.sliderCurrentIndex--;

    const prevElement = this.sliderItems.item(this.sliderCurrentIndex);
    this.changeSlide(prevElement);
    this.checkShowed(prevElement, true);
  }

  goNext() {
    this.sliderCurrentIndex++;

    const nextElement = this.sliderItems.item(this.sliderCurrentIndex);
    this.changeSlide(nextElement);
    this.checkShowed(nextElement);
  }

  /**
   *
   * @param {HTMLElement} el
   */
  changeSlide(el) {
    this.removeActive();
    this.addActive(el);
    this.changeOtherElements(el);
  }

  /**
   *
   * @param {HTMLElement} el
   * @param {boolean} prev
   */
  checkShowed(el, prev = false) {
    if (!el.classList.contains('showed')) {
      if (prev) {
        this.sliderItemsShowed
          .item(this.sliderItemsShowed.length - 1)
          .classList.remove('showed');
      } else {
        this.sliderItemsShowed.item(0).classList.remove('showed');
      }
      this.setShowedItems();
      el.classList.add('showed');
      let index = this.getIndexSliderItem(el);
      if (prev) {
        index =
          index + (this.showedItems - 1) < this.sliderItems.length - 1
            ? index + (this.showedItems - 1)
            : index;
      }
      const offset =
        index > this.showedItems - 1
          ? (index - (this.showedItems - 1)) * this.sliderItemWidth
          : 0;
      this.sliderOuter.style.transform = `translateX(${
        offset ? -offset + 'px' : offset
      })`;

      console.log(offset);

      if (!offset) {
        this.setFirstShowed();
      }
    }
  }

  /**
   *
   * @param {HTMLElement} el
   * @return {number}
   */
  getIndexSliderItem(el) {
    const arr = Array.from(this.sliderItems);
    return arr.indexOf(el);
  }

  setShowedItems() {
    this.sliderItemsShowed = this.slider.querySelectorAll(
      '.about-history-slider-item.showed'
    );
  }

  clearShowedItems() {
    this.sliderItemsShowed.forEach((el) => {
      el.classList.remove('showed');
    });
  }
}
